import React, { useState } from "react";
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    package: 'Essential' // Updated to match new package names
  });

  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`/send-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus('Message sent successfully! We\'ll get back to you soon!');
        setFormData({ name: '', email: '', message: '', package: 'Essential' });
        setTimeout(() => setStatus(''), 5000);
      } else {
        setStatus('Failed to send message. Please try again.');
      }
    } catch (err) {
      console.error('Error sending email:', err);
      setStatus('Failed to send message. Please try again.');
    }
  };

  return (
    <div className="contact-page">
      <div className="hero-container">
        <div className="hero-glass">
          <h1>Contact Us</h1>
          <p>Send us a message and we'll get back to you as soon as possible!</p>
          <form onSubmit={handleSubmit} className="contact-form">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <label htmlFor="package" className="package-label">Package Type</label>
            <select
              name="package"
              id="package"
              value={formData.package}
              onChange={handleChange}
              required
            >
              <option value="Essential">Essential</option>
              <option value="Deluxe">Deluxe</option>
              <option value="Premium">Premium</option>
            </select>

            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
            />
            <button type="submit">Send Message</button>
          </form>
          {status && <p className={`status ${status.includes('Failed') ? 'error' : ''}`}>{status}</p>}
        </div>
      </div>
    </div>
  );
};

export default Contact;
